export enum Sport {
  FOOTBALL = "FOOTBALL",
  BASKETBALL = "BASKETBALL",
  VOLLEYBALL = "VOLLEYBALL",
  CRICKET = "CRICKET",
  TABLETENNIS = "TABLETENNIS",
  HANDBALL = "HANDBALL",
  ICEHOCKEY = "ICEHOCKEY",
  TENNIS = "TENNIS",
  SNOOKER = "SNOOKER",
  BASEBALL = "BASEBALL",
  RUGBY = "RUGBY",
  AMERICAN_FOOTBALL = "AMERICAN_FOOTBALL",
  BADMINTON = "BADMINTON",
  COCK_FIGHT = "COCK_FIGHT",
  BULL_FIGHT = "BULL_FIGHT",
  BOXING = "BOXING",
}
